import Sidebar from "../../Components/Sidebar";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tag } from "antd";
import {
  getConversation,
  getConversationMessages,
  updateConversationStatus,
} from "../../redux/actions/conversationAction";
import ConversationThread from "../../Components/Chat/ConversationThread";
import ExtractedDataPanel from "../../Components/Chat/ExtractedDataPanel";
import CustomButton from "../../Components/CustomButton";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import Button from "react-bootstrap/Button";
import { IoReorderThree } from "react-icons/io5";
import "../../styles/pages/conversations.css";

const statusColors = {
  active: "green",
  completed: "default",
  paused: "gold",
  failed: "red",
};

const ConversationDetail = () => {
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let conversationid = id;
        await getConversation({ conversationid });
        await getConversationMessages({ conversationid });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [id]);

  const conversation = useSelector(
    (state) => state?.conversationReducer?.CurrentConversation
  );

  const messages = useSelector(
    (state) => state?.conversationReducer?.ConversationMessages
  );

  const handleStatusUpdate = async (newStatus) => {
    try {
      const res = await updateConversationStatus({
        conversationid: id,
        status: newStatus,
      });
      if (res?.data) {
        await getConversation({ conversationid: id });
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const targetUser = conversation?.targetuserid;
  const currentStatus = conversation?.status;

  return (
    <div className='dashboard'>
      <Sidebar show={show} setShow={setShow} />
      <div className='dashboard-right-side space-y-4'>
        <div className='d-flex gap-2 align-items-center mb-2'>
          <Button
            className='d-block d-lg-none bg-transparent text-dark border border-0'
            onClick={handleShow}
          >
            <IoReorderThree size={30} />
          </Button>
        </div>

        <div className='flex gap-3 items-start w-full text-[#4A4D54]'>
          <div className='h-8 flex items-center justify-center'>
            <button
              className='border-0 bg-transparent p-0 cursor-pointer flex items-center justify-center'
              onClick={() => window.history.back()}
            >
              <IoArrowBackCircleOutline size={28} />
            </button>
          </div>
          <div className='flex-1'>
            <div className='flex items-center gap-3 flex-wrap'>
              <h5 className='text-2xl font-bold mb-0'>
                {targetUser?.name || targetUser?.Name || "Unknown Target"}
              </h5>
              <Tag color={statusColors[currentStatus] || "default"}>
                {currentStatus
                  ? currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1)
                  : "N/A"}
              </Tag>
            </div>
            <p className='text-[#3A3B3F] text-xs mb-0'>
              {targetUser?.phone || "N/A"} {targetUser?.role ? ` - ${targetUser.role}` : ""}
            </p>
          </div>
          <div className='conversation-actions flex gap-2 flex-wrap'>
            {currentStatus === "active" && (
              <>
                <CustomButton
                  text='Pause'
                  onClick={() => handleStatusUpdate("paused")}
                  style={{ width: "auto", padding: "0 16px" }}
                />
                <CustomButton
                  text='End'
                  onClick={() => handleStatusUpdate("completed")}
                  style={{ width: "auto", padding: "0 16px" }}
                />
              </>
            )}
            {currentStatus === "paused" && (
              <>
                <CustomButton
                  text='Resume'
                  onClick={() => handleStatusUpdate("active")}
                  style={{ width: "auto", padding: "0 16px" }}
                />
                <CustomButton
                  text='End'
                  onClick={() => handleStatusUpdate("completed")}
                  style={{ width: "auto", padding: "0 16px" }}
                />
              </>
            )}
          </div>
        </div>

        <div className='conversation-content-wrapper'>
          <div className='conversation-thread-container'>
            <ConversationThread messages={messages || []} />
          </div>
          <div className='conversation-extracted-panel'>
            <ExtractedDataPanel extractedData={conversation?.extractedData || []} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversationDetail;
